module.exports = __webpack_public_path__ + "assets/08b3ac24f986b02c799011b878531dc7.png";